function findSpan(rectangle, axis, isMain) {

  if ((axis === 'row') === isMain) {
    return { start: rectangle.left, end: rectangle.right };
  }

  return { start: rectangle.top, end: rectangle.bottom };

}

// Cells form a new flex line when they begin past the cross end of the current line.
function groupLines(rectangles, axis) {

  const lines = [];
  let line = null;

  for (let index = 0; index < rectangles.length; index++) {

    const span = findSpan(rectangles[index], axis, false);

    if (line === null || span.start >= line.end) {
      line = { first: index, last: index, start: span.start, end: span.end };
      lines.push(line);
      continue;
    }

    line.last = index;
    line.start = Math.min(line.start, span.start);
    line.end = Math.max(line.end, span.end);

  }

  return lines;

}

function countBefore(rectangles, line, position, flow) {

  let count = 0;

  for (let index = line.first; index <= line.last; index++) {

    const span = findSpan(rectangles[index], flow.axis, true);
    const centre = (span.start + span.end) / 2;

    if ((centre < position) !== flow.reversed) {
      count++;
    }

  }

  return count;

}

function findPointPosition(point, axis, isMain) {

  if ((axis === 'row') === isMain) {
    return point.x;
  }

  return point.y;

}

// The index a block dropped on the layout itself (a gap or its padding) goes to, or -1 when the
// pointer is across the axis, outside every line, so the layout acts as an ordinary block.
export function findLayoutIndex(cellRectangles, point, flow) {

  const lines = groupLines(cellRectangles, flow.axis);
  const crossPosition = findPointPosition(point, flow.axis, false);
  const mainPosition = findPointPosition(point, flow.axis, true);

  for (let index = 0; index < lines.length; index++) {

    if (crossPosition < lines[index].start) {
      if (index === 0) {
        return -1;
      }
      return lines[index].first;
    }

    if (crossPosition <= lines[index].end) {
      return lines[index].first + countBefore(cellRectangles, lines[index], mainPosition, flow);
    }

  }

  return -1;

}
